import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatStatusAndamento'
})
export class FormatStatusAndamentoPipe implements PipeTransform {
  transform(status: any, formSituacao: boolean = false): string {
    if (status == 3 && formSituacao) {
      return 'Conclusão';
    }
    else if (status == 3) {
      return 'Término';
    }
    else if (status == 4) {
      return 'Cancelada';
    }
    else if (formSituacao) {
      return 'Previsão de Conclusão';
    }
    else {
      return 'Término planejado';
    }
  }
}